export default __webpack_public_path__ + "static/pro-steel-celik-uretim-yazilimi-2267ca39a3e89f5f79325c00510af101.png";